/**
 * AcceptInviteSuccess Component
 *
 * Success message after accepting an invite
 */
import styles from './AcceptInviteSuccess.module.css';

function AcceptInviteSuccess({ success, handleDone }) {
    return (
        <>
            <div className={styles.successBox}>
                <div className={styles.checkmark}>✓</div>
                <p className={styles.successTitle}>
                    Success!
                </p>
                <p className={styles.successMessage}>
                    You now have access to <strong>{success}</strong>
                </p>
            </div>

            <div className={styles.buttonContainer}>
                <button
                    onClick={handleDone}
                    className={styles.doneButton}
                >
                    Done
                </button>
            </div>
        </>
    );
}

export default AcceptInviteSuccess;
